// extracted by mini-css-extract-plugin
module.exports = {"card-container":"card-container_card-container_2R7hm","blank":"card-container_blank_2GK6c"};